import { UnknownError, NetworkError, ConnectionAbortedError, TimeoutError, InvalidSdkConfigurationError, InvalidRegionOrHostError, InvalidRegionError, InvalidHostError } from "@smash-sdk/core";
import { GenericError as CreateImageGenericError } from "./types/CreateImage/CreateImageError";
import { InvalidParameterError as CreateImageInvalidParameterError } from "./types/CreateImage/CreateImageError";
import { UnauthorizedError as CreateImageUnauthorizedError } from "./types/CreateImage/CreateImageError";
import { ConflictError as CreateImageConflictError } from "./types/CreateImage/CreateImageError";
import { InternalServerError as CreateImageInternalServerError } from "./types/CreateImage/CreateImageError";
import { BadGatewayError as CreateImageBadGatewayError } from "./types/CreateImage/CreateImageError";
import { GatewayTimeoutError as CreateImageGatewayTimeoutError } from "./types/CreateImage/CreateImageError";
import { GenericError as GetImageGenericError } from "./types/GetImage/GetImageError";
import { InvalidParameterError as GetImageInvalidParameterError } from "./types/GetImage/GetImageError";
import { UnauthorizedError as GetImageUnauthorizedError } from "./types/GetImage/GetImageError";
import { NotFoundError as GetImageNotFoundError } from "./types/GetImage/GetImageError";
import { InternalServerError as GetImageInternalServerError } from "./types/GetImage/GetImageError";
import { BadGatewayError as GetImageBadGatewayError } from "./types/GetImage/GetImageError";
import { GatewayTimeoutError as GetImageGatewayTimeoutError } from "./types/GetImage/GetImageError";
export const errors = {
    CreateImage: {
        InvalidParameterError: CreateImageInvalidParameterError,
        UnauthorizedError: CreateImageUnauthorizedError,
        ConflictError: CreateImageConflictError,
        InternalServerError: CreateImageInternalServerError,
        BadGatewayError: CreateImageBadGatewayError,
        GatewayTimeoutError: CreateImageGatewayTimeoutError,
        GenericError: CreateImageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetImage: {
        InvalidParameterError: GetImageInvalidParameterError,
        UnauthorizedError: GetImageUnauthorizedError,
        NotFoundError: GetImageNotFoundError,
        InternalServerError: GetImageInternalServerError,
        BadGatewayError: GetImageBadGatewayError,
        GatewayTimeoutError: GetImageGatewayTimeoutError,
        GenericError: GetImageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateImageError: {
        InvalidParameterError: CreateImageInvalidParameterError,
        UnauthorizedError: CreateImageUnauthorizedError,
        ConflictError: CreateImageConflictError,
        InternalServerError: CreateImageInternalServerError,
        BadGatewayError: CreateImageBadGatewayError,
        GatewayTimeoutError: CreateImageGatewayTimeoutError,
        GenericError: CreateImageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetImageError: {
        InvalidParameterError: GetImageInvalidParameterError,
        UnauthorizedError: GetImageUnauthorizedError,
        NotFoundError: GetImageNotFoundError,
        InternalServerError: GetImageInternalServerError,
        BadGatewayError: GetImageBadGatewayError,
        GatewayTimeoutError: GetImageGatewayTimeoutError,
        GenericError: GetImageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InvalidSdkConfigurationError,
    InvalidRegionOrHostError,
    InvalidRegionError,
    InvalidHostError,
};
